var _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftPosition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "232.4px",
    height: "302px",
    viewBox: "0 0 232.4 302",
    enableBackground: "new 0 0 232.4 302",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 131.8,
    y: 60.8,
    fill: "#494848",
    width: 0,
    height: 40.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 35.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 42,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 48.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 55.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 62.1,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 68.8,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 75.5,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 82.3,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 89,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 95.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 102.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 109.1,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 115.8,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 122.6,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 129.3,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 136,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 142.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 149.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 156.1,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 162.9,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 169.6,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 176.3,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 183,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 189.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 196.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 203.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 209.9,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 216.6,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 223.3,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 23.2,
    cy: 230,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 24.2,
    cy: 236.7,
    r: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 35.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 42,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 48.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 55.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 62.1,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 68.8,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 75.5,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 82.3,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 89,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 95.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 102.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 109.1,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 115.8,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 122.6,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 129.3,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 136,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 142.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 149.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 156.1,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 162.9,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 169.6,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 176.3,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 183,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 189.7,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 196.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 203.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 209.9,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 216.6,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 223.3,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 230,
    r: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#706F6F",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    d: "M26.6,261.5L26.6,261.5 c-1.8,0-3.2-1.5-3.2-3.2v-14.7c0-1.8,1.5-3.2,3.2-3.2h0c1.8,0,3.2,1.5,3.2,3.2v14.7C29.8,260,28.4,261.5,26.6,261.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    d: "M23.2,33.6v202.7l6.5-0.8c0-5,0-201.9,0-201.9 H23.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeWidth: 0.6955,
    strokeMiterlimit: 10,
    cx: 29.6,
    cy: 235.8,
    r: 1.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeMiterlimit: 10,
    d: "M12.3,193.5c0,0,0,2.6-0.4,3.7c-0.7,1.8,0.5,2.3,0.5,2.3h208 c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H12.3L12.3,193.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeMiterlimit: 10,
    d: "M12.3,188.2c0,0,0.1,1.9-0.4,3.7c-1.1,2.3,0.5,2.3,0.5,2.3h208 c0,0,1.1-0.3,0.5-2c-0.4-2.2-0.7-4-0.7-4H12.3L12.3,188.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeMiterlimit: 10,
    d: "M14.9,10.6h205.7l-0.3,143.3c0,0,0.1,1.1,0,4.3 c0.5,1.9,1,30.3-0.5,30.3c-1.6,0-202.7,0-206.8,0c-2.9,0-0.9-27.9-1.2-33.8c0-1.4,0-144.1,0-144.1L14.9,10.6L14.9,10.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPosition);
export default __webpack_public_path__ + "static/media/LeftPosition.0b25b013cedd81a01ff8f6010366986e.svg";
export { ForwardRef as ReactComponent };